/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_SettingsInputs */

const en_us2_clubs_settings = /** @type {(inputs: Clubs_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club rules`)
};

const pt_br2_clubs_settings = /** @type {(inputs: Clubs_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regras do clube`)
};

const es_419_clubs_settings = /** @type {(inputs: Clubs_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reglas del club`)
};

const pt_pt2_clubs_settings = /** @type {(inputs: Clubs_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regras do clube`)
};

const fr_fr2_clubs_settings = /** @type {(inputs: Clubs_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règles du club`)
};

const de_de2_clubs_settings = /** @type {(inputs: Clubs_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubregeln`)
};

const it_it2_clubs_settings = /** @type {(inputs: Clubs_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regole del club`)
};

/**
* | output |
* | --- |
* | "Club rules" |
*
* @param {Clubs_SettingsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_settings = /** @type {((inputs?: Clubs_SettingsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_SettingsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_settings(inputs)
	if (locale === "es-419") return es_419_clubs_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_settings(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_settings(inputs)
	if (locale === "de-DE") return de_de2_clubs_settings(inputs)
	if (locale === "it-IT") return it_it2_clubs_settings(inputs)
	return en_us2_clubs_settings(inputs)
});
export { clubs_settings as "clubs.settings" }